module.exports = __webpack_public_path__ + "img/milano-bicocca.6d96b933.jpg";